import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  ODAnalysis,
  setAnalysisStatus,
  useGetAnalysisStatusQuery,
} from 'state/originDestinationSlices';
import { selectCurrentAnalysisId, selectProject } from 'state/workflowSlice';

import { PROCESS_STATUS } from 'appConstants';
import { ProcessStatus } from 'appTypes';

const terminalStatuses: ProcessStatus[] = [
  PROCESS_STATUS.DONE,
  PROCESS_STATUS.ERROR,
];

function useQueryAnalysisStatus(analysis: ODAnalysis): ProcessStatus {
  const project_slug = useAppSelector(selectProject);
  const [currStatus, setCurrStatus] = useState<ProcessStatus>(analysis.status);

  const skip =
    !project_slug ||
    !analysis.analysis_id ||
    (currStatus ? terminalStatuses.includes(currStatus) : false);

  const { data } = useGetAnalysisStatusQuery(
    { project_slug, analysis_id: analysis.analysis_id },
    {
      skip,
      pollingInterval: 60 * 1000, // update every min
    },
  );
  // update from server
  useEffect(() => {
    const status = data?.status as ProcessStatus;
    if (status && status !== currStatus) setCurrStatus(status);
  }, [data?.status]);

  return currStatus;
}

export function useODStatus(analysis: ODAnalysis) {
  const dispatch = useAppDispatch();
  const currentId = useAppSelector(selectCurrentAnalysisId);
  const status = useQueryAnalysisStatus(analysis);
  const { analysis_id } = analysis;

  useEffect(() => {
    if (currentId && currentId === analysis_id)
      dispatch(setAnalysisStatus(status));
  }, [status, currentId]);

  useEffect(() => {
    if (!currentId) dispatch(setAnalysisStatus(undefined));
  }, [currentId]);

  return status;
}
